export default __webpack_public_path__ + "static/media/telco_bg.3c862fae.svg";